<div id="widget-root"></div>
<div *ngIf="auth.user.verified">Your Account has been verified successfully.</div>
<!-- <div class="d-flex justify-content-around address_field mt-4">
    
    <button  [routerLink]="['/dashboard']" routerLinkActive="router-link-active"  type="button" class="btn  primary-btn sm-12 h-auto w-100 btn-widthFull">Done</button>
</div> -->
<!-- <div class="w-100 d-flex align-items-end justify-content-center mt-5">
    <p class="h3 text-center color-blue font-weight-bold customPage-heading">Document verfication</p>
</div>
<div class="container border mt-5">
    <div class="text-center  font-weight-bold info-heading" style="padding:16px 0px;">
        <span class="text-center pl-5">Document</span><span class="float-right"><a  href="#"> <i class="fas fa-plus-circle mr-1"></i>Add</a></span>
    </div>
</div> -->